import { render } from "./AdminServices.vue?vue&type=template&id=20f04b1e&scoped=true"
import script from "./AdminServices.vue?vue&type=script&lang=js"
export * from "./AdminServices.vue?vue&type=script&lang=js"

import "./AdminServices.vue?vue&type=style&index=0&id=20f04b1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f04b1e"]])

export default __exports__